import React, { useState, useEffect } from 'react';
import { Form, Input, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { getProjectById } from '../../../api/project';
import { getSDGCertificates } from '../../../api/rating';

interface SDGRatingFormProps {
  form: any;
  updateParentDetails: any;
}

const SDGRatingForm: React.FC<SDGRatingFormProps> = ({ form, updateParentDetails }) => {
  const { id, creditingPeriodId } = useParams<{ id, creditingPeriodId: string }>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchProject() {
      setLoading(true);
      try {
        const projectData = await getProjectById(id, Number(creditingPeriodId));
        const sdgCertificateData = await getSDGCertificates();
        updateParentDetails({
          sdgCertificates: sdgCertificateData.response,
        });
        setLoading(false);
        const sdgRating = projectData.response.sdg_rating;
        const sdgFields = {};
        for (let i = 1; i <= 17; i++) {
          const sdgKey = `sdg_${i}_score`;
          if (sdgRating?.[sdgKey] !== undefined) {
            sdgFields[sdgKey] = sdgRating[sdgKey];
          }
        }
        form.setFieldsValue({
          sdgCertificate: sdgRating?.sdg_certificate?.code,
          sdgImpactRating: sdgRating?.sdg_impact_rating ? `+${sdgRating.sdg_impact_rating}` : '',
          sdgImpactRatingNotes: sdgRating?.sdg_impact_rating_notes,
          ...sdgFields,
        });
      } catch (error) {
        setLoading(false);
        console.error('Error fetching project:', error);
      }
    }

    fetchProject();
  }, [id, form]);

  return (
    <>
      <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />} fullscreen />
      <div className='flex gap-4'>
        <Form.Item
          label="SDG Rating"
          name="sdgImpactRating"
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="SDG Labels"
          name="sdgCertificate"
          className='w-48'
        >
          <Input disabled />
        </Form.Item>
      </div>
      <Form.Item
        label="SDG Notes (Internal use)"
        name="sdgImpactRatingNotes"
      >
        <Input.TextArea />
      </Form.Item>
      <div className='flex flex-wrap gap-x-4'>
        {[...Array(17)].map((_, index) => {
          const sdgNumber = index + 1;
          const fieldName = `sdg_${sdgNumber}_score`;
          return (
            <Form.Item
              key={`sdg_${sdgNumber}`}
              label={`SDG ${sdgNumber} Score`}
              name={fieldName}
            >
              <Input type="number" disabled />
            </Form.Item>
          );
        })}
      </div>
    </>
  );
};

export default SDGRatingForm;
